import React from 'react';
import SafeIcon from '../common/SafeIcon';
import {FaApple} from 'react-icons/fa';

export const AppStoreButton=()=> (
  <a
    href="https://apps.apple.com/us/app/wingcue-your-ai-wingman/id6806146653"
    target="_blank"
    rel="noopener noreferrer"
    className="group flex items-center justify-center gap-4 bg-white text-black px-9 py-4 rounded-2xl transition-all duration-300 w-[250px] hover:bg-gray-100 hover:scale-[1.02] active:scale-[0.98]"
    style={{boxShadow: '0 4px 24px rgba(255,255,255,0.12)'}}
  >
    <SafeIcon icon={FaApple} className="text-[32px] flex-shrink-0" />
    <div className="flex flex-col items-start leading-none">
      <span className="text-[10px] font-semibold tracking-widest uppercase text-black/50 mb-1">Download on the</span>
      <span className="text-[20px] font-bold tracking-tight">App Store</span>
    </div>
  </a>
);

export const PlayStoreButton=()=> (
  <a
    href="https://play.google.com/store/apps/details?id=com.rork.wingcue&pli=1"
    target="_blank"
    rel="noopener noreferrer"
    className="block w-[250px] h-[68px] rounded-2xl overflow-hidden border border-white/30 transition-all duration-300 hover:border-white/60 hover:scale-[1.02] active:scale-[0.98]"
  >
    <img
      src="https://global.divhunt.com/2af1aa34d0e9e3ecc86ecb561fe66838_9163.avif"
      alt="Get it on Google Play"
      className="w-full h-full object-fill"
    />
  </a>
);